import { Stack } from "@mui/system";
import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import TrafficClickIdentifierFilter from "./TrafficClickIdentifierFilter";
import CreateTrafficClickIdentifierModal from "../TrafficClickIdentifierModal/CreateTrafficClickIdentifierModal";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import {
  setOpenModalType,
  setPage,
  setSelectedEntityType,
} from "../../../../../features/metaEntitiesSlice";
import { useEffect } from "react";
import store from "../../../../../store";
import { useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

const TrafficClickIdentifierFilterCard = () => {
  const dispatch = useDispatch();
  const { selectedEntityType, metaEntityList, openModalType } = useSelector(
    (state: any) => state?.metaEntity
  );
  const MetaTrafficSourceIdentifierNames = metaEntityList?.map(
    (item: any) => item?.identifier
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const response = useSelector(selectUserData);
  const hasCreateTrafficClickIdentifierPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "create_traffic_click_identifiers"
  );

  const handleModalOpen = (modalType: string) => {
    dispatch(setOpenModalType(modalType));
  };
  const handleCloseModal = () => {
    dispatch(setOpenModalType(null));
  };

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    store.dispatch(setSelectedEntityType(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Stack
        flexDirection={"row"}
        justifyContent={"start"}
        gap={4}
        sx={{ paddingBlock: "16px" }}
      >
        <Autocomplete
          sx={{ width: "350px" }}
          data-tracker="233"
          options={
            MetaTrafficSourceIdentifierNames
              ? MetaTrafficSourceIdentifierNames
              : []
          }
          value={selectedEntityType}
          onChange={(_, newValue: any) => {
            dispatch(setSelectedEntityType(newValue));
            // Reset page to 0 when searching
            store.dispatch(setPage(0));
            setSearchParams((prevParams) => {
              const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
              if (newValue) {
                updatedParams.search = newValue; // Set new value
              } else {
                delete updatedParams.search; // Remove from URL if cleared
              }
              // Also update page param in URL to reflect reset
              updatedParams.page = "0";
              return updatedParams;
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Traffic Click Identifier Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "10px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <TrafficClickIdentifierFilter />
          {hasCreateTrafficClickIdentifierPermission ? (
            <Button
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              onClick={() => handleModalOpen("create")}
              data-tracker="236"
            >
              Create New Identifier <AddIcon sx={{ ml: 1 }} />
            </Button>
          ) : (
            <>
              <Button
                variant="contained"
                color="secondary"
                sx={{ whiteSpace: "nowrap" }}
                disabled
              >
                Create New Identifier <AddIcon sx={{ ml: 1 }} />
              </Button>
            </>
          )}
        </Stack>
      </Stack>
      {openModalType === "create" && (
        <CreateTrafficClickIdentifierModal
          open={true}
          handleClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default TrafficClickIdentifierFilterCard;
